module.exports = __webpack_public_path__ + "static/media/celular-man.fe1f7840.jpg";